/* 
 * FadeTransition.js
 * Created on 7-apr-2017
 * @author Swen Meeuwes for &ranj
 */

import AnimationOptions from "../AnimationOptions";
import AnimationFactory from "../AnimationFactory";

export default class FadeTransition {
    constructor(type) {
        this.type = type;
    };

    animate(screenNavigator, screen, animationOptions) {
        return new Promise(function (resolve, reject) {
            // If no animation options are specified, use the default animation options
            if (animationOptions === undefined)
                animationOptions = new AnimationOptions();

            var beginState = { alpha: 0 };
            var endState = { alpha: 0 };

            switch (this.type) {
                case AnimationFactory.FADE_IN:
                    endState.alpha = 1;
                    break;
                case AnimationFactory.FADE_OUT:
                    beginState.alpha = 1;
                    break;
                default:
                    // Log warning
                    break;
            }

            // Set screen to begin state
            screen.set(beginState);

            // Execute the tween with the given animation options
            createjs.Tween
                .get(screen)
                .wait(animationOptions.delay)
                .to(endState, animationOptions.duration, animationOptions.ease)
                .call(function () {
                    // Handle callbacks in animation options
                    if (animationOptions.callbacks)
                        for (var i = 0; i < animationOptions.callbacks.length; i++) {
                            animationOptions.callbacks[i].call(this);
                        }
                    resolve();
                }.bind(this));
        }.bind(this));
    };
}